<template>
	<div @click="$emit('click', $event)" :style="`width: 100%; text-align: ${item.alignment}`" v-if="isConditionMet">
		<img class="mx-brand-logo" alt="Business logo" :src="logoUrl" :style="`width:${item.width}px`">
  </div>
</template>

<script>
	import RendererMixin from "@/modules/forms/v2/schema/RendererMixin";
	import { formLogo } from '@moxie/branding';

	export default {
		name: 'ImageBlock',
		inject: { formBranding: { default: null } },

		props: ['accountLogo','item', 'results','builder'],

		mixins: [RendererMixin],

		components: {},

		data: function() {
			return {};
		},

		mounted() {},

		beforeDestroy() {},

		methods: {},

		computed: {
			logoUrl() {
				return formLogo(this.formBranding ? this.formBranding() : null, this.accountLogo, undefined, true, this.item.logoVariant);
			},
		},
	};
</script>

<style scoped lang="scss"></style>
